export default {
  footerQuickLinks: "Schnelllinks",
  footerAboutRLS: "Über RLS",
  footerOurJourney: "Unsere Reise",
  footerLeadershipTeam: "Führungsteam",
  footerContactUs: "Kontaktieren Sie uns",
  footerConnectWithUs: "Verbinden Sie sich mit uns",
  footerAllRightsReserved: "2025 Refex Life Sciences. Alle Rechte vorbehalten.",
  footerPrivacyPolicy: "Datenschutzrichtlinie",
  footerTermsOfService: "Nutzungsbedingungen",
};

